import React, { useEffect } from "react";
import { BsArrowUp } from "react-icons/bs";

const ScrollBarBtn = () => {
  useEffect(() => {
    let scrollBtn = document.querySelector(".scrollBtn");
    window.onscroll = function () {
      scrollFunction();
    };
    function scrollFunction() {
      if (
        document.body.scrollTop > 300 ||
        document.documentElement.scrollTop > 300
      ) {
        scrollBtn.style.display = "block";
      } else {
        scrollBtn.style.display = "none";
      }
    }
    function scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    scrollBtn.addEventListener("click", () => {
      scrollToTop();
    });
  }, []);
  return (
    <div className="w-12 h-12 z-10 text-2xl hidden scrollBtn">
      <button className="w-full h-full flex items-center justify-center relative overflow-hidden text-blue-700 group hover:text-blue-500 duration-300">
        <BsArrowUp />
        <span className="w-full h-[1px] bg-lightTextDesignColor absolute top-0 inline-block -translate-y-[.3px] group-hover:translate-y-0 transition-transform duration-300"></span>
        <span className="w-full h-[1px] bg-lightTextDesignColor absolute bottom-0 inline-block translate-y-[.3px] group-hover:translate-y-0 transition-transform duration-300"></span>
        <span className="w-[1px] h-full bg-lightTextDesignColor absolute left-0 inline-block -translate-x-[.3px] group-hover:translate-x-0 transition-transform duration-300"></span>
        <span className="w-[1px] h-full bg-lightTextDesignColor absolute right-0 inline-block translate-x-[.3px] group-hover:translate-x-0 transition-transform duration-300"></span>
      </button>
    </div>
  );
};

export default ScrollBarBtn;
